import React from "react";
import { NavLink } from "react-router-dom";

export type SegmentedTab = {
  key: string;
  label: React.ReactNode;
  to?: string;
  hidden?: boolean;
  onClick?: () => void;
  disabled?: boolean;
};

type Props = {
  items: SegmentedTab[];
  activeKey?: string;
  className?: string;
  fullWidth?: boolean;
  size?: "sm" | "md";
  variant?: "default" | "primary";
  replace?: boolean;
};

const baseBtn =
  "rounded-full flex h-8 px-3 justify-center items-center gap-1 transition-colors";

const activeClsDefault =
  "bg-bg-900 text-white dark:bg-bg-900-dark dark:text-font";
const inactiveClsDefault =
  "text-font-600 dark:text-font-600-dark hover:bg-bg-900 dark:hover:bg-bg-900-dark hover:text-white dark:hover:text-font";
const disabledClsDefault =
  "text-font-600 dark:text-font-600-dark opacity-60 cursor-not-allowed";

const activeClsPrimary =
  "bg-primary text-font-dark hover:bg-btn-active active:bg-btn-active";
const inactiveClsPrimary =
  "bg-primary text-font-dark hover:bg-btn-active active:bg-btn-active";
const disabledClsPrimary =
  "bg-primary/50 text-font-dark cursor-not-allowed";

export default function SegmentedTabs({
                                        items,
                                        activeKey,
                                        className,
                                        fullWidth,
                                        size = "md",
                                        variant = "default",
                                        replace = false
                                      }: Props) {
  const sizeCls = size === "sm" ? "h-8 py-1 px-3 text-xs" : "h-10 py-2 px-3";
  return (
    <div className={`flex flex-row flex-wrap gap-4 items-center ${fullWidth ? "w-full" : ""} ${className ?? ""}`}>
      {items.filter(i => !i.hidden).map((item) => {
        const isActive = item.key === activeKey;
        const activeCls = variant === "primary" ? activeClsPrimary : activeClsDefault;
        const inactiveCls = variant === "primary" ? inactiveClsPrimary : inactiveClsDefault;
        const disabledCls = variant === "primary" ? disabledClsPrimary : disabledClsDefault;
        const classes = `${baseBtn} ${sizeCls} ${isActive ? activeCls : item.disabled ? disabledCls : inactiveCls} ${fullWidth ? "w-full" : ""}`;
        if (item.onClick || item.disabled || !item.to || item.to === "#") {
          return (
            <button
              key={item.key}
              type="button"
              onClick={item.onClick}
              disabled={item.disabled}
              className={classes}
            >
              {item.label}
            </button>
          );
        }
        return (
          <NavLink
            key={item.key}
            to={item.to}
            className={classes}
            replace={replace}
          >
            {item.label}
          </NavLink>
        );
      })}
    </div>
  );
}


